import { Card } from "components"
import { FormProvider, useForm } from "react-hook-form"
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

import { useGet } from "hooks"
import { IEntityGST } from "services/core/genericEntityGST"
import { IGetOcorrenciaByIDResponse, IGetOcorrenciaByIDParams } from "services/GST/WorkAccidentOccurrence"
import { SPACING } from "utils"

import AddNewForm from './components/AddNewForm'
import { UseWorkAccidentOccurrence } from '../../context'
import { IForm } from "./types"
import { useEffect } from "react"

interface IAddNewProps {
  justRead?: boolean
}

const scheme = yup.object().shape({
  cdCnpjPassaporte: yup.string().required('Campo obrigatório.'),
  cdTipoFornecedor: yup.string().required('Campo obrigatório.'),
  idCentro: yup.string().required('Campo obrigatório.'),
  nmEmpresa: yup.string().required('Campo obrigatório.'),
  nmFornecedor: yup.string().required('Campo obrigatório.'),
  nuCompetencia: yup.string().required('Campo obrigatório.'),
  qtAtendimentoAmb: yup.string().required('Campo obrigatório.'),
  qtCaf: yup.string().required('Campo obrigatório.'),
  qtDanoMaterial: yup.string().required('Campo obrigatório.'),
  qtDiasPerdidos: yup.string().required('Campo obrigatório.'),
  qtIncendio: yup.string().required('Campo obrigatório.'),
  qtPs: yup.string().required('Campo obrigatório.'),
  qtSaf: yup.string().required('Campo obrigatório.'),
  qtTotalCafSafSp: yup.string().required('Campo obrigatório.'),
  qtTotalOcorrencias: yup.string().required('Campo obrigatório.'),
  qtTrajetoCaf: yup.string().required('Campo obrigatório.'),
  qtTrajetoPs: yup.string().required('Campo obrigatório.'),
  qtTrajetoSaf: yup.string().required('Campo obrigatório.'),
})

const AddNew: React.FC<IAddNewProps> = ({
  justRead = false
}) => {
  const methods = useForm<IForm>({
    resolver: yupResolver(scheme),
    defaultValues: {
      cdCnpjPassaporte: '',
      cdTipoFornecedor: '0',
      idCentro: undefined,
      nmEmpresa: '',
      nmFornecedor: '',
      nuCompetencia: new Date(),
      qtAtendimentoAmb: undefined,
      qtCaf: undefined,
      qtDanoMaterial: undefined,
      qtDiasPerdidos: undefined,
      qtIncendio: undefined,
      qtPs: undefined,
      qtSaf: undefined,
      qtTotalCafSafSp: undefined,
      qtTotalOcorrencias: undefined,
      qtTrajetoCaf: undefined,
      qtTrajetoPs: undefined,
      qtTrajetoSaf: undefined
    }
  })
  const {
    idOcorrenciaSelecionado,
  } = UseWorkAccidentOccurrence()

  useGet<IGetOcorrenciaByIDParams, IEntityGST<IGetOcorrenciaByIDResponse>>({
    api: 'Gst',
    condition: justRead && idOcorrenciaSelecionado > 0, // Condição para fazer a requisição
    params: { idOcorrencia: idOcorrenciaSelecionado },
    formActions: { setValue: methods.setValue }, // Seta a resposta da requisição no formulário
    url: 'Ocorrencia/GetOcorrenciaById'
  })

  const hht = methods.watch('hht')
  const CAF = methods.watch('qtCaf')
  const SAF = methods.watch('qtSaf')
  const qtdDiasPerdidos = methods.watch('qtDiasPerdidos')

  useEffect(() => {
    const { setValue } = methods

    if (hht) {
      setValue('hht', Number(hht))
      setValue('taxaFrequenciaCAFSAF', (((Number(CAF) + Number(SAF)) * 1000000) / Number(hht)))
      setValue('taxaFrequenciaCAF', (Number(CAF) * 1000000) / Number(hht))
      setValue('taxaGravidade', (Number(qtdDiasPerdidos) * 1000000) / Number(hht))
    } else {
      setValue('hht', 0)
      setValue('taxaFrequenciaCAFSAF', 0)
      setValue('taxaFrequenciaCAF', 0)
      setValue('taxaGravidade', 0)
    }
  }, [hht])

  return (
    <FormProvider {...methods}>
      <Card
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
        borderRadius={`0px 10px 0px 0px`}
      >
        <AddNewForm justRead={justRead} />
      </Card>
    </FormProvider>
  )
}

export default AddNew
